import BlSheetMv from './BlSheetMv.vue'

BlSheetMv.install = function(Vue) {
  Vue.component(BlSheetMv.name, BlSheetMv)
}

export default BlSheetMv
